// @ts-strict-ignore
import { dayjs } from '@/extendedDayjs';
import { antGrey } from '@/components/styles/globalStyles';
import * as React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import { formatDateWithTimezone } from '@/timeHelpers';

interface ChecklistItemTargetTimeProps {
    isDisabled: boolean;
    dueDate: string;
    effectiveTimezone?: string;
    use24HourTimeFormat?: boolean;
}

export const TargetCompletionDueView = (props: ChecklistItemTargetTimeProps) => {
    const textColor = props.isDisabled ? antGrey.grey6 : antGrey.grey8;
    const timezone = props.effectiveTimezone || dayjs.tz.guess();
    const now = dayjs().tz(timezone);
    const dueDate = dayjs(props.dueDate).tz(timezone);
    const isCLIDueToday = dueDate.isSame(now, 'day');
    const isCLIPastDue = now.isAfter(props.dueDate);

    //     If CLI is not past due and is due today
    if (!isCLIPastDue && isCLIDueToday) {
        const totalMinutes = dueDate.diff(now, 'minute');
        const hourDifference = Math.floor(totalMinutes / 60);
        const minuteDifference = totalMinutes % 60;
        return (
            <Text style={{ columnGap: 12, display: 'flex', color: textColor }}>
                <ClockCircleOutlined />
                in {hourDifference}h, {minuteDifference}m
            </Text>
        );

        //     If CLI is not past due and not today
    } else if (!isCLIPastDue) {
        const formattedCliDueDate = formatDateWithTimezone(
            dueDate,
            'shortMonthDateWithTime',
            timezone,
            props.use24HourTimeFormat ?? false,
        );
        return (
            <Text style={{ color: textColor, columnGap: 12, display: 'flex' }}>
                <ClockCircleOutlined />
                <div>{formattedCliDueDate}</div>
            </Text>
        );

        //     If CLI is past due
    } else if (isCLIPastDue) {
        let totalMinutes = now.diff(dueDate, 'minute');
        if (totalMinutes < 0) {
            totalMinutes = -totalMinutes;
        }

        const totalHours = Math.floor(totalMinutes / 60);
        const days = Math.floor(totalMinutes / 60 / 24);
        const hours = totalHours % 24;
        const minutes = totalMinutes % 60;

        const timeParts = [];
        if (days > 0) timeParts.push(`${days}d`);
        if (hours > 0 || days > 0) timeParts.push(`${hours}h`);
        timeParts.push(`${minutes}m`);

        return (
            <Text type="warning" style={{ columnGap: 12, display: 'flex' }}>
                <ClockCircleOutlined />
                <div>Overdue by {timeParts.join(', ')}</div>
            </Text>
        );
    } else {
        return null;
    }
};
